export default __webpack_public_path__ + "static/media/BrainBreak cards19.d3bf7342.png";